export const ErrorHandler = error => {
  const { response } = error;
  if (!response) return Promise.reject(error); 
  if (response?.status === 404) {
    window.location.href = '/not-found';
  }
  return Promise.reject(error.response);
};
